import { SET_TOTAL_TRANSCRIPT_AMOUNT, 
         SET_TRANSCRIPTS_COST_SUCCESS, 
         SET_TRANSCRIPTS_COST_ERROR,         
         SET_REVIEW_PAY_STATIC_SUCCESS,
         SET_REVIEW_PAY_STATIC_ERROR,RESET_REVIEW_DATA } from "../actionTypes";


const initialState = {
    totalTranscriptAmount:0,
    transcriptsCost: [],
    payStaticData:{}
}

const reviewConfirm = (state = {...initialState},action) =>{
    switch(action.type){
        case SET_TOTAL_TRANSCRIPT_AMOUNT: {
            return {
              ...state,
              totalTranscriptAmount: action.payload.amount
            };
        }
        case SET_TRANSCRIPTS_COST_SUCCESS: {
            return{
                ...state,
                transcriptsCost: action.payload.costs
            }
        }
        case SET_TRANSCRIPTS_COST_ERROR:{
            return{
                ...state,
                totalTranscriptAmount:0,
                transcriptsCost: []
            }
        }
        case SET_REVIEW_PAY_STATIC_SUCCESS:{
            return{
                ...state,
                payStaticData:action.payload.staticData
            }
        }
        case SET_REVIEW_PAY_STATIC_ERROR:{
            return{
                ...state,
                payStaticData:{}
            }
        }
        case RESET_REVIEW_DATA:{
            return {...initialState};
        }
        default : {
            return state;
        }
    }
}
export default reviewConfirm;